// Botão "Já regularizei" (só admin): zera a marca de problema de conta da
// conexão Oficial no backend. A confirmação usa o AerosConfirmModal (nunca
// window.confirm). O estado novo chega pelo socket (company-<id>-whatsapp).
import React, { useState } from "react";
import { makeStyles, alpha } from "@material-ui/core/styles";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
import api from "../../services/api";
import toastError from "../../errors/toastError";
import { i18n } from "../../translate/i18n";
import { AEROS, stateText } from "../../styles/aerosTokens";
import AerosConfirmModal from "../AerosConfirmModal";

const useStyles = makeStyles((theme) => ({
  botao: {
    display: "inline-flex", alignItems: "center", gap: 6, alignSelf: "flex-start",
    minHeight: 44, padding: "0 12px", borderRadius: 10, fontSize: 13, fontWeight: 700,
    cursor: "pointer", background: "none", touchAction: "manipulation",
    color: stateText(theme, AEROS.warning, "warning"),
    border: `1px solid ${alpha(AEROS.warning, 0.5)}`,
    "&:hover": { backgroundColor: alpha(AEROS.warning, 0.16) },
    "&:focus-visible": { outline: `2px solid ${theme.palette.primary.main}`, outlineOffset: 2 },
    "& .MuiSvgIcon-root": { fontSize: 16 },
  },
}));

const BotaoJaRegularizei = ({ whatsappId, user, className }) => {
  const classes = useStyles();
  const [aberto, setAberto] = useState(false);
  const [enviando, setEnviando] = useState(false);

  if (user?.profile !== "admin") return null;

  const confirmar = async () => {
    setEnviando(true);
    try {
      await api.put(`/whatsapp/${whatsappId}/account-issue/clear`);
      setAberto(false);
    } catch (err) {
      toastError(err);
    } finally {
      setEnviando(false);
    }
  };

  return (
    <>
      <button
        type="button"
        className={`${classes.botao} ${className || ""}`}
        onClick={() => setAberto(true)}
        data-testid="ja-regularizei"
      >
        <CheckCircleOutlineIcon aria-hidden="true" />
        {i18n.t("metaErrors.markResolved")}
      </button>
      <AerosConfirmModal
        open={aberto}
        onClose={() => setAberto(false)}
        onConfirm={confirmar}
        loading={enviando}
        tone="warning"
        primary
        icon={<CheckCircleOutlineIcon />}
        title={i18n.t("metaErrors.markResolvedTitle")}
        description={i18n.t("metaErrors.markResolvedBody")}
        confirmLabel={i18n.t("metaErrors.markResolvedConfirm")}
      />
    </>
  );
};

export default BotaoJaRegularizei;
